const appLoaderLang = {
	loading: {
		tag: 'app.loader.loading',
		fr: 'Chargement en cours...',
		en: 'Loading...',
	},
};

export default appLoaderLang;
